const SubIcon = ({
  viewBox = "0 0 24 24",
  size = 24,
  color = "#000",
  ...props
}) => (
  <svg
    viewBox="0 0 1024 1024"
    version="1.1"
    p-id="10497"
    width={size}
    height={size}
    {...props}
  >
    <path
      d="M0 512a36.571429 36.571429 0 0 1 36.571429-36.571429h950.857142a36.571429 36.571429 0 0 1 0 73.142858H36.571429A36.571429 36.571429 0 0 1 0 512z"
      fill={color}
      p-id="10498"
    ></path>
  </svg>
);

export default SubIcon;
